// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__fdMY4","modal":"Modal_modal__CbPhN","moveInBottom":"Modal_moveInBottom__WVtm+"};